import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';
import { registerEmailSelector } from 'src/store/auth';

import { Button } from 'src/components';

import { BREADCRUMBS_DATA, ROUTE } from 'src/constants';

import {
  ArrowRightBottomIcon,
  BackgroundImage,
  CheckImage,
  EllipseImage,
  StarsImage,
} from 'src/assets';
import './forgotPasswordSuccess.scss';

export const ForgotPasswordSuccess = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const email = useSelector(registerEmailSelector);

  useEffect(() => {
    if (!email) {
      navigate(ROUTE.HOME);
    }
  }, [navigate, email, i18n.language]);

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.FORGOT_PASSWORD));
  }, [dispatch]);

  const onClickContinue = useCallback(() => {
    navigate(ROUTE.AUTH.SIGNIN?.replace(':language', i18n.language));
  }, [i18n.language, navigate]);

  return (
    <div className="forgot-password-success">
      <div className="forgot-password-success-content">
        <div>
          <div className="forgot-password-success-title">
            <h1>
              {t('forgotSuccess:reset')} <blue-text>{t('forgotSuccess:access')}</blue-text>
            </h1>
            <div className="forgot-password-success-subtitle">{t('forgotSuccess:success')}</div>
          </div>

          <div className="forgot-password-success-form">
            <div className="forgot-password-success-form-button">
              <Button
                title={t('title:continue')}
                onClick={onClickContinue}
                icon={ArrowRightBottomIcon}
              />
            </div>
          </div>
        </div>

        <div className="forgot-password-success-images-container">
          <div className="forgot-password-success-images-wrapper">
            <img
              src={BackgroundImage}
              alt={BackgroundImage}
              className="forgot-password-success-images-background image"
            />
            <img
              src={CheckImage}
              alt={CheckImage}
              className="forgot-password-success-images-check image"
            />
            <img
              src={StarsImage}
              alt={StarsImage}
              className="forgot-password-success-images-stars image"
            />
            <img
              src={EllipseImage}
              alt={EllipseImage}
              className="forgot-password-success-images-ellipse1 image"
            />
            <img
              src={EllipseImage}
              alt={EllipseImage}
              className="forgot-password-success-images-ellipse2 image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
